export default "__VITE_ASSET__bONSdb4Q__"